<template>
  <v-dialog v-model="internalShow" max-width="500px">
    <v-card>
      <v-card-title class="headline primary white--text pa-3">
        Kết xuất kết quả tra cứu
        <v-spacer></v-spacer>
        <v-btn icon dark @click="internalShow = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-tabs v-model="tab" background-color="grey lighten-4" grow>
        <v-tab>Xuất Dữ Liệu</v-tab>
        <v-tab>Xuất Hình Ảnh</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <!-- Tab Xuất Dữ liệu -->
        <v-tab-item>
          <v-card flat>
            <v-card-text class="pt-4">
              <div class="subtitle-2 mb-2">Chọn trường dữ liệu:</div>
              <v-sheet
                class="overflow-y-auto mb-4"
                max-height="200"
                style="border: 1px solid #e0e0e0; border-radius: 4px;"
              >
                <v-list dense>
                  <v-list-item v-for="(field, index) in availableFields" :key="index">
                    <v-list-item-action>
                      <v-checkbox
                        v-model="selectedFields"
                        :value="field.code"
                        hide-details
                        dense
                        color="primary"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ field.name }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-sheet>

              <v-select
                v-model="dataFormat"
                :items="dataFormats"
                label="Định dạng kết xuất"
                outlined
                dense
                hide-details
              ></v-select>
            </v-card-text>
            <v-card-actions class="px-4 pb-4">
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="exportData" :disabled="selectedFields.length === 0">
                <v-icon left>mdi-file-download</v-icon> Tải File Dữ Liệu
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>

        <!-- Tab Xuất Hình ảnh -->
        <v-tab-item>
          <v-card flat>
            <v-card-text class="pt-4">
              <div class="subtitle-2 mb-2">Ảnh xem trước (Đã cố định vị trí):</div>
              <div 
                v-if="previewImage" 
                style="border: 1px solid #ccc; border-radius: 4px; overflow: hidden; height: 180px; display: flex; align-items: center; justify-content: center; background: #f5f5f5;"
                class="mb-4"
              >
                <img :src="previewImage" style="max-width: 100%; max-height: 100%; object-fit: contain;" />
              </div>
              <div v-else class="mb-4 text-center grey--text">
                Không thể tải ảnh xem trước
              </div>
              <div class="subtitle-2 mb-2">Định dạng ảnh:</div>
              <v-select
                v-model="imageFormat"
                :items="imageFormats"
                label="Định dạng kết xuất"
                outlined
                dense
                hide-details
                class="mb-4"
              ></v-select>
            </v-card-text>
            <v-card-actions class="px-4 pb-4">
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="exportImage" :disabled="!previewImage">
                <v-icon left>mdi-image-outline</v-icon> Tải Ảnh Xuống
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import * as Papa from 'papaparse'

export default {
  name: 'ExportFeatureDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    fields: {
      type: Array,
      default: () => [],
    },
    featureData: {
      type: Object,
      default: () => ({}),
    },
    previewImage: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      tab: 0,
      selectedFields: [],
      dataFormat: 'xlsx',
      dataFormats: [
        { text: 'Excel (.xlsx)', value: 'xlsx' },
        { text: 'CSV (.csv)', value: 'csv' },
      ],
      imageFormat: 'png',
      imageFormats: [
        { text: 'PNG Image (.png)', value: 'png' },
        { text: 'JPG Image (.jpg)', value: 'jpeg' },
      ],
    }
  },
  computed: {
    internalShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
    availableFields() {
      // Chỉ lấy các trường không phải dạng geometry
      return this.fields.filter(f => f.type !== 'geometry')
    }
  },
  watch: {
    show(val) {
      if (val) {
        // Mặc định chọn tất cả các trường
        this.selectedFields = this.availableFields.map(f => f.code)
      }
    }
  },
  methods: {
    exportData() {
      // 1. Tạo object dữ liệu chỉ chứa các trường được chọn
      const rowData = {}
      this.selectedFields.forEach(code => {
        const fieldObj = this.availableFields.find(f => f.code === code)
        if (fieldObj) {
          const val = this.featureData[code]
          rowData[fieldObj.name] = (val !== null && val !== undefined) ? val : ''
        }
      })

      const dataArray = [rowData]

      // 2. Xuất theo format đã chọn
      const fileName = `KetQuaTraCuu_${new Date().getTime()}`
      
      if (this.dataFormat === 'xlsx') {
        const ws = XLSX.utils.json_to_sheet(dataArray)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1")
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${fileName}.xlsx`)
      } 
      else if (this.dataFormat === 'csv') {
        const csvContent = Papa.unparse(dataArray)
        const blob = new Blob(["\ufeff" + csvContent], { type: 'text/csv;charset=utf-8;' }) // \ufeff là BOM cho tiếng Việt
        saveAs(blob, `${fileName}.csv`)
      }

      this.internalShow = false
    },
    exportImage() {
      if (!this.previewImage) return;

      if (this.imageFormat === 'jpeg') {
        // Convert base64 PNG to JPEG
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          // Fill white background for JPEG (since PNG might have transparency)
          ctx.fillStyle = "#FFFFFF";
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0);
          const jpegDataUrl = canvas.toDataURL("image/jpeg");
          this.triggerDownload(jpegDataUrl, "jpg");
        };
        img.src = this.previewImage;
      } else {
        // Default is PNG
        this.triggerDownload(this.previewImage, "png");
      }
    },
    triggerDownload(dataUrl, ext) {
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = `BanDoTraCuu_${new Date().getTime()}.${ext}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.internalShow = false;
    }
  }
}
</script>

<style scoped>
</style>
